module.exports = __webpack_public_path__ + "img/picture-frame.a924772f.jpg";